module.exports = __webpack_public_path__ + "img/biaoshu.694608a4.png";